<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
                <div>
                  Tipo Actividad<select class="form-control" v-model="configuration.TIPO_ACTIVIDAD" @change="updateActivityType">
                    <option value="1">1. De compleja a incompleja </option>
                    <option value="2">2. De incompleja a compleja</option>
                  </select>
                </div>
            </div>
            <div class="col-md-4 mt-2">
            <br/>
             <div>
                Sistema<select class="form-control" v-model="configuration.SISTEMA">
                  <option value="0">Horas </option>
                  <option value="1">Grados</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 mt-2">
              <br/>
              <br/>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ORAL"
                id="verbaloral">
                <label class="custom-control-label" for="verbaloral">Verbal oral</label>
              </div>
            </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row  class="justify-content-md-center">
          <b-col col lg="2" style="text-align:center"><h6>Grados</h6></b-col>
          <b-col col lg="2" style="text-align:center"><h6>Minutos</h6></b-col>
          <b-col col lg="2" style="text-align:center"><h6>Segundos</h6></b-col>
          <b-col col lg="2" style="text-align:center"><h6>Unidad Incompleja</h6></b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="2">
                <ValidationProvider rules="required|max:3" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'GRADOS' + index"
                    v-model="arrayEleOperation[index].GRADOS" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="2">
                <ValidationProvider rules="required|between:0,59" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'MINUTOS' + index"
                    v-model="arrayEleOperation[index].MINUTOS" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="2">
                <ValidationProvider rules="required|between:0,59" v-slot="{ errors }">
                  <b-form-input type="number"
                    :disabled="parseInt(arrayEleOperation[index].UNIDAD_INCOMPLEJA) === 1"
                    v-bind:id="'SEGUNDOS' + index"
                    v-model="arrayEleOperation[index].SEGUNDOS" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
               <b-col col lg="2">
                <select class="form-control"
                  v-model="arrayEleOperation[index].UNIDAD_INCOMPLEJA"
                  @change="arrayEleOperation[index].SEGUNDOS=0">
                  <!--<option value="0">
                    {{parseInt(configuration.SISTEMA) === 0 ? "Horas" : "Grados"}}
                  </option>-->
                  <option value="1">Minutos</option>
                  <option value="2">Segundos</option>
                    </select>
               </b-col>
          </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, between } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
extend('max', {
  validate(value, args) {
    return value.length <= args.length;
  },
  params: ['length'],
  message: 'Máx. {length} dígitos',
});
extend('between', {
  ...between,
  message: 'Entre {min} y {max}.',
});


export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla SUMARESTAALG_CONF
      configuration: {
        ID: null,
        TIPO_ACTIVIDAD: 1,
        SISTEMA: 1,
        VERBAL_ORAL: false,
        EJERCICIOS_ID: -1,
      },
    };
  },
  methods: {
    updateActivityType() {
      this.arrayEleOperation.forEach((element, i) => {
        this.arrayEleOperation[i].UNIDAD_INCOMPLEJA = 1;
      });
    },
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        GRADOS: 0,
        MINUTOS: 0,
        SEGUNDOS: 0,
        UNIDAD_INCOMPLEJA: 2,
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('conversionsexagesimal/getconversionsexagesimal', {
          params: {
            ejercicios_id: id,
          },
        });

        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            GRADOS: element.GRADOS,
            MINUTOS: element.MINUTOS,
            SEGUNDOS: element.SEGUNDOS,
            UNIDAD_INCOMPLEJA: element.UNIDAD_INCOMPLEJA,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
